import * as React from 'react'
import { FC } from 'react'

import Box from '@mui/material/Box'

interface Props {
  isComplete: boolean
}

export const RequirementsIndicatorIcon: FC<Props> = (props) => {
  const { isComplete } = props

  return (
    <Box display="flex" flex-direction="column" alignItems="center">
      <img
        alt={`Requirement ${isComplete ? 'Complete' : 'Incomplete'}`}
        src={`static-assets/icons/closing-requirements/circle-indicator-${
          isComplete ? '' : 'in'
        }complete.svg`}
      />
    </Box>
  )
}

RequirementsIndicatorIcon.displayName = 'RequirementsIndicatorIcon'
